export const CarpetasAdjuntos = {
    RequisitosAdmision: 'AdmissionRequirement',
    RequisitosGraduacion: 'GraduationRequirements',
    AnotacionesEstudiantes: 'StudentAnnotations',
    AdjuntosEstudiantes: 'StudentAttachments'
}

export default CarpetasAdjuntos;